export interface Navigation {
  key: string;
  path: string;
  title: string;
  icon: string;
}

const navigationConfig: Navigation[] = [
  {
    key: "andqo",
    path: "/andqo/home",
    title: "Liste d'ordres",
    icon: "andqoHome",
  },
  {
    key: "andqo",
    path: "/andqo/category",
    title: "Catégories",
    icon: "andqoCategory",
  },
  {
    key: "sncf",
    path: "/sncf/home",
    title: "Nouveau Fichier",
    icon: "sncfHome",
  },
  {
    key: "sncf",
    path: "/sncf/status",
    title: "Status",
    icon: "sncfStatus",
  },
];

export default navigationConfig;
